import React from 'react'
import { CheckoutLegalTerms } from '@/views/PayItForward/PayItForwardProjectCheckoutOfferView/CheckoutLegalTerms'

export const CheckoutLegalTermsExpComponent: React.VFC = () => {
  return <CheckoutLegalTerms />
}
